/*
 Note: Keep in sync with:
 https://github.com/radix-ui/themes/blob/main/packages/radix-ui-themes/src/helpers/extract-margin-props.ts
*/
export function extractMarginProps(props) {
  const { m, mx, my, mt, mr, mb, ml, ...rest } = props
  return {
    m,
    mx,
    my,
    mt,
    mr,
    mb,
    ml,
    rest,
  }
}
